import React, { useContext, useMemo } from "react";
import { withRouter, useHistory, Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { List, ListItem } from "@material-ui/core";
import { Apps } from "@material-ui/icons";
import CustomDropdown from "./../../components/CustomDropdown/CustomDropdown.js";
import { AppContext } from "../../contexts/appContext.js";
import styles from "./../../assets/style/headerLink";
const useStyles = makeStyles(styles);

const HeaderLinks = () => {
  const classes = useStyles();
  let history = useHistory();
  const { updateLogin, updateUser, setNotifications, user } =
    useContext(AppContext);
  const LogoutFunction = (e) => {
    e.preventDefault();
    updateLogin(false);
    updateUser(null);
    setNotifications([]);
    localStorage.removeItem("Token");
    history.push("/login");
  };

  const checkManageType = useMemo(() => {
    if (user instanceof Object) {
      if (user.manage_type) return "/settings/type";
      else if (user.manage_template) return "/settings/template";
      else if (user.manage_user) return "/settings/user";
      else if (user.manage_group_bu) return "/settings/group_bu";
    }
  }, [user]);

  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        {user && (
          <CustomDropdown
            noLiPadding
            buttonText="Menu"
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList={[
              <div
                id="fullname_user"
                className={classes.dropdownLink}
                style={{
                  textAlign: "center",
                  borderBottomWidth: "1px",
                  borderBottomColor: "#DCDCDC",
                  borderBottomStyle: "solid",
                }}
              >
                <div id="fullname_user" className={classes.fontLarge}>
                  {user.fullname}
                </div>
                <div id="fullname_user" className={classes.fontSamll}>
                  {user.role}
                </div>
              </div>,
              <Link to="/change-password" className={classes.dropdownLink}>
                เปลี่ยนรหัสผ่าน
              </Link>,
              <Link to="/mail" className={classes.dropdownLink}>
                รายการรอส่ง Mail
              </Link>,
              user.view_promotion && (
                <Link to="/promotion" className={classes.dropdownLink}>
                  Promotion
                </Link>
              ),
              user.view_set_price && (
                <Link to="/set_price" className={classes.dropdownLink}>
                  Set Price
                </Link>
              ),
              user.view_min_day && (
                <Link to="/min_day" className={classes.dropdownLink}>
                  Min/Day
                </Link>
              ),
              <Link to="/product" className={classes.dropdownLink}>
                Product
              </Link>,
              user.view_report && (
                <Link to="/report1" className={classes.dropdownLink}>
                  Report
                </Link>
              ),
              (user.manage_user ||
                user.manage_type ||
                user.manage_template ||
                user.manage_group_bu) && (
                <Link to={checkManageType} className={classes.dropdownLink}>
                  Setting
                </Link>
              ),
              <div onClick={LogoutFunction} className={classes.dropdownLink}>
                Logout
              </div>,
            ]}
          />
        )}
      </ListItem>
    </List>
  );
};
export default withRouter(HeaderLinks);
